import React, { useEffect, useState, useContext } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { handleAuth2RedirectUri } from '../../shared/UtilityFunctions';
import { CmicContext } from '../../context/CmicContext';
import axios from 'axios';

const Officepopup = () => {
	const {
		currentOfficeTheme,
		userInfo,
		showToast,
		setUserInfo,
		resetCMiCData,
		setShowToast,
		setServerType,
		serverType,
		setIsCloudUser,
		isCloudUser,
		removeToast,
	} = useContext(CmicContext);

	const authenticateUser = (clientId, tenantId, scope) => {
		return new Promise(async resolve => {
			const msalConfig = {
				auth: {
					clientId: clientId,
					redirectUri: handleAuth2RedirectUri(),
					authority: `https://login.microsoftonline.com/${tenantId}`,
					// grant_type: "authorization_code",
				},
				cache: {
					cacheLocation: 'sessionStorage',
					storeAuthStateInCookie: false,
				},
			};

			const msalInstance = new PublicClientApplication(msalConfig);

			try {
				await msalInstance.initialize();
				const data = await msalInstance.loginPopup({ scopes: [`${scope}`] });
				resolve({ ...data });
			} catch (error) {
				console.error('Login error:', error);
			}
		});
	};

	useEffect(async () => {
		const params = new URLSearchParams(window.location.hash.replace('#/window', ''));

		const clientId = 'b7ff582c-bb55-4a68-b79e-2e59caa7b6bf';
		const redirectUri = 'https://localhost:3000/taskpane.html#/popup';

		function generateRandomString(length) {
			const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
			let result = '';
			const array = new Uint8Array(length);
			window.crypto.getRandomValues(array);
			array.forEach(c => (result += charset[c % charset.length]));
			return result;
		}

		async function generateCodeChallenge(codeVerifier) {
			const encoder = new TextEncoder();
			const data = encoder.encode(codeVerifier);
			const digest = await crypto.subtle.digest('SHA-256', data);
			return btoa(String.fromCharCode(...new Uint8Array(digest)))
				.replace(/\+/g, '-')
				.replace(/\//g, '_')
				.replace(/=+$/, '');
		}

		const codeVerifier = generateRandomString(60);
		localStorage.setItem('code_verifier', codeVerifier);

		const codeChallenge = await generateCodeChallenge(codeVerifier);

		const authorizationUrl =
			`https://login.microsoftonline.com/0f09972d-7e48-4deb-a2d9-28dcee7dea82/oauth2/v2.0/authorize` +
			`?client_id=${clientId}` +
			`&response_type=code` +
			`&redirect_uri=${encodeURIComponent(redirectUri)}` +
			`&scope=User.Read` +
			`&code_challenge=${codeChallenge}` +
			`&code_challenge_method=S256` +
			`&response_mode=fragment` +
			`&x-client-SKU=msal.js.browser` +
			`&x-client-VER=3.26.1` +
			`&client_info=1` +
			`&prompt=none` +
			`&login_hint=Suraj.Sinha@newgensoft.com` +
			`&X-AnchorMailbox=UPN:Suraj.Sinha@newgensoft.com`;

		//   try {
		//     const result = await axios.get(authorizationUrl);
		//    console.log(result)
		//   }
		// catch(error) {
		//   console.log(error);
		// }

		const popup = window.location.assign(authorizationUrl, 'authPopup', 'width=500,height=600');
		console.log('window.location.assign', window.location);

		// Listen for messages from the popup
		window.addEventListener('message', event => {
			if (event.origin !== 'http://localhost:3000') {
				console.warn('Received message from unknown origin:', event.origin);
				return;
			}

			if (event.data) {
				console.log('Authorization code received:', event.data);
				popup.close(); // Close the popup
			}
		});

		//   let tenantId = params.get("tenantId");
		//   let clientId = params.get("clientId");
		//   let scope = params.get("scope");
		//   console.log("serverType",clientId, tenantId, scope)
		//   if(clientId !== null || tenantId !== null || scope !== null) {
		//  // const authData = await authenticateUser(clientId, tenantId, scope);

		//   console.log(authData);
		//   Office.context.ui.messageParent(JSON.stringify(authData));
		//   }
		//    window.opener.postMessage(authData, "*");
	}, []);

	return <div className="App" style={{ color: 'white' }}></div>;
};

export default Officepopup;
